// extracted by mini-css-extract-plugin
export default {"wrapper":"KanbanTableW_wrapper__XgVSS","item__wrapper":"KanbanTableW_item__wrapper__bvPsP"};